import { VueExtension } from '../../utils/extensions/vue';
import Modal from './modal.jsx';
import './modal.scss';

VueExtension.WithInstall(Modal);

export default Modal;
